import React, { useState } from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import 'core/theme/datepicker.scss'
import { it } from 'date-fns/locale'
import i18n from 'stylewhere/i18n'

const DatePicker = (ReactDatePicker as any).default ?? ReactDatePicker
registerLocale('it', it)

interface CalendarPickerProps {
  startDate: Date | null
  endDate: Date | null
  onChange: (dates: [Date | null, Date | null]) => void
}

export const CalendarPicker: React.FC<CalendarPickerProps> = ({ startDate, endDate, onChange }) => {
  const [range, setRange] = useState<{ start: Date | null; end: Date | null }>({ start: startDate, end: endDate })

  const handleCalendarChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates
    setRange({ start, end })

    if (start && end) {
      onChange([start, end])
    }
  }
  return (
    <DatePicker
      selected={startDate}
      onChange={handleCalendarChange}
      startDate={range.start}
      endDate={range.end}
      selectsRange
      inline
      locale={i18n.language}
    />
  )
}
